var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhilippinesGrandlotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 601 601",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M350.477 549.162c24.529-45.992 39.859-98.116 24.529-137.975-30.661-73.587-125.711-107.314-147.173-193.165-20.543-90.45 25.755-186.42 114.979-211.255C329.015 4.927 314.91 3.7 300.5 3.7 136.463 3.7 3.7 136.77 3.7 300.5c0 154.226 117.432 280.856 267.978 295.573 30.048-10.731 61.322-16.25 78.799-46.912z",
    fill: "#070572"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M342.812 6.766c-89.224 24.836-136.442 110.38-116.206 200.83 21.463 85.851 110.38 104.861 141.041 178.448 15.331 39.859 13.491 104.554-12.878 144.107-19.623 29.128-60.709 54.27-90.45 65.002 9.505.92 26.369 2.146 36.18 2.146 164.037 0 296.8-133.069 296.8-296.8.307-149.626-110.38-273.191-254.487-293.734z",
    fill: "#ff0008"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M352.93 371.021C302.953 605.578 72.381 484.773 72.381 484.773s133.376 33.421 169.249-75.12c0 0-168.023 75.12-233.331-136.135 0 0 70.827 107.007 173.542 65.308 0 0-173.542-84.625-65.308-266.445 0 0-18.09 130.616 84.625 175.075l62.549-52.737s76.346-184.58 265.219-77.879c0 0-131.843-22.076-170.783 75.12 0 0 198.684-55.497 234.558 141.654 0 0-69.294-109.767-176.302-70.827 0 0 186.113 94.436 69.294 265.219 0 0 44.459-140.121-84.625-162.504l-48.138 5.519z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.667 133.397c-20.236 67.761.307 110.073 16.25 130.616 7.665 10.118 111.607 120.498 111.607 120.498 15.944 17.17 26.369 38.94 29.741 62.242 14.717 106.701-78.186 147.48-78.186 147.48 22.076-1.533 125.097-29.128 148.707-125.097 23.609-95.663-41.699-165.264-41.699-165.264l-80.639-87.384c-16.557-17.17-32.194-39.246-36.487-62.855-16.557-91.983 86.158-146.56 86.158-146.56s-122.032 15.33-155.452 126.324z",
    fill: "#f5f406"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippinesGrandlotto);
export default __webpack_public_path__ + "static/media/philippines_grandlotto.113c5bc6fee9f144cba38c7a4a9f9ccf.svg";
export { ForwardRef as ReactComponent };